module.exports = entry => {
  const node = entry.node ? entry.node : entry
  return node.node_locale === 'sv-SE' || node.enableLocalization
}
